import axios from "axios";
import { getAuthToken } from "./cookieUtils";

// Function to get JD list with pagination and filters
export const getJDList = async (params = {}, clientId) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const url = `${baseURL}/jds`;

    // Build query parameters
    const queryParams = new URLSearchParams();
    if (clientId) queryParams.append('client_id', clientId);
    if (params.search) queryParams.append('search', params.search);
    if (params.job_type) queryParams.append('job_type', params.job_type);
    if (params.experience_level) queryParams.append('experience_level', params.experience_level);
    if (params.location) queryParams.append('location', params.location);
    if (params.status) queryParams.append('status', params.status);
    if (params.priority) queryParams.append('priority', params.priority);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.skip) queryParams.append('skip', params.skip);
    if (params.sort_by) queryParams.append('sort_by', params.sort_by);
    if (params.sort_order) queryParams.append('sort_order', params.sort_order);

    const fullUrl = queryParams.toString() ? `${url}?${queryParams.toString()}` : url;

    const response = await axios.get(fullUrl, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
        "X-Client-ID": clientId,
      },
    });
    console.log("Response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// Function to get JD by ID
export const getJDById = async (jdId, clientId) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const url = `${baseURL}/jds/${jdId}`;

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
        "X-Client-ID": clientId,
      },
    });
    console.log("Response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// Function to create JD
export const createJD = async (jdData, clientId) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const url = `${baseURL}/jds`;

    const response = await axios.post(url, jdData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
        "X-Client-ID": clientId,
      },
    });
    console.log("Response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// Function to update JD
export const updateJD = async (jdId, jdData, clientId) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const url = `${baseURL}/jds/${jdId}`;

    const response = await axios.put(url, jdData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
        "X-Client-ID": clientId,
      },
    });
    console.log("Response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// Function to delete JD
export const deleteJD = async (jdId, clientId) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const url = `${baseURL}/jds/${jdId}`;

    const response = await axios.delete(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
        "X-Client-ID": clientId,
      },
    });
    console.log("Response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// Function to parse JD file
export const parseJDFile = async (formData, clientId) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const url = `${baseURL}/jds/parse`;

    const response = await axios.post(url, formData, {
      headers: {
        Authorization: `Bearer ${Token}`,
        "X-Client-ID": clientId,
      },
    });
    console.log("Response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// Function to generate JD from prompt
export const generateJD = async (promptData, clientId) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const url = `${baseURL}/jds/generate`;

    const response = await axios.post(url, promptData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
        "X-Client-ID": clientId,
      },
    });
    console.log("Response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// Function to generate screening questions for JD
export const generateScreeningQuestions = async (jdData, clientId) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const url = `${baseURL}/jds/generate_screening_questions`;

    const response = await axios.post(url, jdData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
        "X-Client-ID": clientId,
      },
    });
    console.log("Response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// Function to upload JD file (alias for parseJDFile for backward compatibility)
export const uploadJDFile = async (file, clientId) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const url = `${baseURL}/jds/parse`;

    const formData = new FormData();
    formData.append('file', file);

    const response = await axios.post(url, formData, {
      headers: {
        Authorization: `Bearer ${Token}`,
        "X-Client-ID": clientId,
      },
    });
    console.log("Response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};
